(function (angular, schoolwork12) {

    'use strict';
    angular.module(schoolwork12.app.administrationTools.name)
		.controller(schoolwork12.app.administrationTools.controllers.fixAdults, [
			'$rootScope', '$scope', '$http', '$timeout', '$interval', '$uibModal','$location', '$state', '$q',
			schoolwork12.app.auth.services.authentication,
			schoolwork12.app.common.services.eventNotification,
			schoolwork12.app.administrationTools.services.administrationToolsSvc,
			schoolwork12.app.fulfillment.services.getAllSchools,
			function ($rootScope, $scope, $http, $timeout, $interval, $uibModal, $location, $state, $q, authentication, 
					eventNotification, administrationToolsSvc, getSchools) {

				console.info("In Fix Adults controller");
				eventNotification.subscribe(schoolwork12.app.auth.events.userLoggedIn,
					function (event, authenticatedUser) {
						console.info('Administration Tools controller: Subscribe On UserLogin Event: '
							.concat(angular.toJson(authenticatedUser)));
							// valid roles for Administration Tools page
							$scope.mainModel.hasTvAdministrationToolsRole = authentication.hasTvAdministrationToolsRole();
					});
				
				$scope.mainModel = {};
				// valid roles for Administration Tools
				if (authentication
						&& authentication.isAuthenticated()) {				
						$scope.mainModel.hasTvAdministrationToolsRole = authentication.hasTvAdministrationToolsRole();
				};	

				//If user refresh the page while is in "Fix Duplicate Adults", this will be redirected back to Admin Tool Main page.
				if(typeof ($scope.$parent.adminTools) == 'undefined' )
					$state.go("adminTools")

				//Initialize global variables and functions
				$scope.showFixAdultSucessAlert = false;
				$scope.showFixAdultErrorAlert = false;
				$scope.isFixDupAdultsBusy = false;
				$scope.badAndGoodDifferNamesError = false;

				//errorMessages
				$scope.fixAdultBadPersonIdRequired = schoolwork12.app.administrationTools.errorMessages.fixAdultBadPersonIdRequired;
            	$scope.fixAdultBadPersonIdDoestExist = schoolwork12.app.administrationTools.errorMessages.fixAdultBadPersonIdDoestExist;
            	$scope.fixAdultGoodPersonIdRequired = schoolwork12.app.administrationTools.errorMessages.fixAdultGoodPersonIdRequired;
				$scope.fixAdultGoodPersonIdDoestExist = schoolwork12.app.administrationTools.errorMessages.fixAdultGoodPersonIdDoestExist;
				$scope.badAndGoodPersonEqualsMsg = schoolwork12.app.administrationTools.errorMessages.fixAdultBadAndGoodPersonEquals;
				$scope.fixAdultBadAndGoodDifferNames = schoolwork12.app.administrationTools.errorMessages.fixAdultBadAndGoodDifferNames;

				$scope.closeFixAdultSuccessAlert = function () {
					$scope.showFixAdultSucessAlert = false;
				}
				
				let resetFormErrors = function () {
					$scope.forms.fixDuplicateAdults['goodPersonId'].$setValidity('goodPersonIdRequired',true);
					$scope.forms.fixDuplicateAdults['goodPersonId'].$setValidity('goodPersonIdDoesntExist',true);
					$scope.forms.fixDuplicateAdults['badPersonId'].$setValidity('badPersonIdRequired',true);
					$scope.forms.fixDuplicateAdults['badPersonId'].$setValidity('badPersonIdDoesntExist',true);
					$scope.forms.fixDuplicateAdults['badPersonId'].$setValidity('badPersonIdInvalid',true);
					$scope.forms.fixDuplicateAdults['goodPersonId'].$setValidity('goodPersonIdInvalid',true);
					$scope.badAndGoodPersonEquals = false;
					$scope.showFixAdultErrorAlert = false;
					$scope.badAndGoodDifferNamesError = false;
					$scope.showFixAdultSucessAlert = false;
				}

				$scope.onlyNumberValidation = function (event){
					var keyCode = event.keyCode;
	
					if ((keyCode < 48 || keyCode > 57)){
						event.preventDefault();
					}
				}

				let validateFixDuplicateAdultForm = function () {
					resetFormErrors();
					let result = true;
					let regex = new RegExp(/^\d+$/);

					if($scope.fixAdults.badPersonId == null || $scope.fixAdults.badPersonId.toString().trim() == ''){
						$scope.forms.fixDuplicateAdults['badPersonId'].$setValidity('badPersonIdRequired',false);
						result = false;
					}else if(!regex.test($scope.fixAdults.badPersonId)){ //validate if badPerson has characters not number in them
						$scope.forms.fixDuplicateAdults['badPersonId'].$setValidity('badPersonIdInvalid',false);
						result = false;
					}

					if($scope.fixAdults.goodPersonId == null || $scope.fixAdults.goodPersonId.toString().trim() == ''){
						$scope.forms.fixDuplicateAdults['goodPersonId'].$setValidity('goodPersonIdRequired',false);
						result = false;
					}else if(!regex.test($scope.fixAdults.goodPersonId)){ //validate if goodPerson has characters not number in them
						$scope.forms.fixDuplicateAdults['goodPersonId'].$setValidity('goodPersonIdInvalid',false);
						result = false;
					}

					if(($scope.fixAdults.badPersonId != null && $scope.fixAdults.goodPersonId != null)
						&& ($scope.fixAdults.badPersonId.trim() != '' && $scope.fixAdults.goodPersonId.trim() != '')
						&& ($scope.fixAdults.badPersonId == $scope.fixAdults.goodPersonId) ){
							$scope.badAndGoodPersonEquals = true;
							result = false;
					}

					return result;
				}

				let checkPersonId = function (personId, personType) {
					let deferred = $q.defer();
					administrationToolsSvc.checkPersonId(authentication.getCurrentUser().keycode, personId)
					.then(function (data) {
						deferred.resolve(data);
					},function(error) {
						deferred.reject(error);
						console.error('Error checking for the personId...'.concat(angular.toJson(error)));
						$scope.showFixAdultErrorAlert = true;
						$scope.fixAdultErrorAlertMsg = "";
						if (error.status == 400) {
							switch (personType) {
								case 'badPerson':{
									$scope.forms.fixDuplicateAdults['badPersonId'].$setValidity('badPersonIdDoesntExist',false);
								}break;
								case 'goodPerson':{
									$scope.forms.fixDuplicateAdults['goodPersonId'].$setValidity('goodPersonIdDoesntExist',false);
								}break;
							}
						} else if (error.status == 401 || error.status == 403) {
							$scope.fixAdultErrorAlertMsg = schoolwork12.app.errorMessages.sessionExpired;
						} else {
							$scope.fixAdultErrorAlertMsg = schoolwork12.app.errorMessages.internalError;
						}
					});
					return deferred.promise;
				};

				$scope.checkAdults = function () {
					if(validateFixDuplicateAdultForm()){
						let checkAdultsPromises = [];
						$scope.isFixDupAdultsBusy = true;
						checkAdultsPromises.push(checkPersonId($scope.fixAdults.badPersonId,"badPerson"));
						checkAdultsPromises.push(checkPersonId($scope.fixAdults.goodPersonId,"goodPerson"));
						$q.all(checkAdultsPromises).then(function ([badPersonInfo,goodPersonInfo]) {
							openFixDupAdultsModal(badPersonInfo,goodPersonInfo);
						})['finally'](function () {
							$scope.isFixDupAdultsBusy = false;
						});
						
					}else{
						$scope.showFixAdultErrorAlert = true;
					}
				}
				
				let openFixDupAdultsModal = function(badPerson,goodPerson){
					let fixDupAdultsModalInstance = $uibModal.open({
						animation: $scope.animationsEnabled,
						templateUrl: 'fixDupAdultsModal.html',
						windowClass: 'alert-Modal',
						keyboard: false,
						backdrop: 'static',
						controller: ['$scope', '$uibModalInstance',
							function($scope, $uibModalInstance) {
								$scope.fixDupAdults = {
									adults:[badPerson,goodPerson],
									byPassValidation: false
								}                           
								$scope.cancelFixDupAdults = function() {                                  
									$uibModalInstance.close(null);
								};
	
								$scope.confirmFixDupAults = function() {
									$scope.fixDupAdults.badPerson = $scope.fixDupAdults.adults[0];
									$scope.fixDupAdults.goodPerson = $scope.fixDupAdults.adults[1];
									delete $scope.fixDupAdults.adults;
									$uibModalInstance.close($scope.fixDupAdults);
								};

								$scope.formatPhone = function(phoneNumberString){
									var phoneCleaned = (phoneNumberString).replace(/\D/g, '')
									var matcher = phoneCleaned.match(/^([(]?\d{3}[)]?)(\d{3}-?)(\d{4})$/)
									if (matcher) {
										return ['(', matcher[1], ')', matcher[2], '-', matcher[3]].join('')
									}
									return null
								};
							}
						],
	
					});

					fixDupAdultsModalInstance.result.then(function(result){
						if(result != null){
							$scope.isFixDupAdultsBusy = true;
							let fixDuplicateAdultsPromise = administrationToolsSvc.fixDuplicateAdults(authentication.getCurrentUser().keycode, result);
							fixDuplicateAdultsPromise.then(function (data) {
								$scope.showFixAdultSucessAlert = true;
							},function(error) {
								console.error('Error fixing Duplicate Adults...'.concat(angular.toJson(error)));
								$scope.showFixAdultErrorAlert = true;
								$scope.fixAdultErrorAlertMsg = "";
								if (error.status == 400) {
									for (var j = 0; j < error.data._errors.length; j++) {
										$scope.fixAdultErrorAlertMsg = $scope.fixAdultErrorAlertMsg + error.data._errors[j] + "\n";
									}
									$scope.badAndGoodDifferNamesError = (~$scope.fixAdultErrorAlertMsg.indexOf("Names of the identified persons are different. Please review and correct the fields."));
								} else if (error.status == 401 || error.status == 403) {
									$scope.fixAdultErrorAlertMsg = schoolwork12.app.errorMessages.sessionExpired;
								} else {
									$scope.fixAdultErrorAlertMsg = schoolwork12.app.errorMessages.internalError;
								}
							})['finally'](function () {
								$scope.isFixDupAdultsBusy = false;
							});
						}
					})
				}
				
			}
		]);

}(angular, schoolwork12));